import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {
    APIResponse
    , MacropointData, OrderStop
    , QuoteOrderLine
} from '../models/models';

const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json'
    })
};

@Injectable()
export class ERPService {
    constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) {
    }

    //public updateERPOrderStopsByQuoteOrderLineId(quoteOrderLineID: number, erpType: string) {
    //    return this.http.get<APIResponse>(this.baseUrl + 'api/ERPOrderStop/UpdateERPOrderStopsByQuoteOrderLineId/?id=' + quoteOrderLineID + '&erpType=' + erpType);
    //}

    public updateERPCustomer(customerID: number, erpType: string) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/ERPCustomer/SaveERPCustomer/?id=' + customerID + '&erpType=' + erpType);
    }

    public syncOrder(orderNumber: string) {
        return this.http.get<QuoteOrderLine[]>(this.baseUrl + 'api/Orders/SyncOrder/?orderNumber=' + orderNumber);
    }

    // TMW Calls
    //public updateTMW(stopList: OrderStop[]) {
    //    return this.http.post<APIResponse>(this.baseUrl + 'api/TMW/UpdateTMW', stopList, httpOptions);
    //}

    //public updateTMWByLineIDLastUpdate(quoteOrderLineID: number) {
    //    return this.http.get<APIResponse>(this.baseUrl + 'api/TMW/UpdateTMWByLineIDLastUpdate/?quoteOrderLineID=' + quoteOrderLineID);
    //}

    // Macropoint Calls
    public saveMacropointData(data: MacropointData) {
        return this.http.post<APIResponse>(this.baseUrl + 'api/Macropoint/SaveMacropointData', data, httpOptions);
    }

    // Macropoint Calls
    public saveMacropointDataList(dataList: MacropointData[]) {
        return this.http.post<APIResponse>(this.baseUrl + 'api/Macropoint/SaveMacropointDataList', dataList, httpOptions);
    }

    public getMacropointLink(quoteOrderLineID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Macropoint/GetMacropointLink/?quoteOrderLineID=' + quoteOrderLineID);
    }
}
